<template>
<div 
  class="compass"
  :class="{
    'still': compassState === 'still',
    'vertical': compassState === 'vertical',
    'left': compassState === 'left',
    'horizontal': compassState === 'horizontal',
    'right': compassState === 'right'
  }"
>
  <div class="compass__still"></div>
  <div class="compass__vertical"></div>
  <div class="compass__left"></div>
  <div class="compass__horizontal"></div>
  <div class="compass__right"></div>
</div>
</template>

<script>
export default {
  name: 'compass',
  props: {
    compassDuration: Array
  },
  data () {
    return {
      compassState: '',
      compassTimeCounter: 0,
      compassInterval: null,
      compassIntervalPeriod: 300
    }
  },
  methods: {
    spin () {
      this.compassState = ''
      this.compassTimeCounter = 0
      let compassIndex = 0
      clearInterval(this.compassInterval)
      this.compassInterval = setInterval (() => {
        if ((compassIndex+1) <= this.compassDuration.length){
          if (this.compassTimeCounter >= this.compassDuration[compassIndex+1]) {
            compassIndex++
          }
        } else {
          if (this.compassTimeCounter >= this.compassDuration[compassIndex]) {
            this.compassTimeCounter = 0
            clearInterval(this.compassInterval)
          }
        }
        if (compassIndex % 2 === 0 && this.compassTimeCounter >= this.compassDuration[compassIndex]){
          if ((this.compassTimeCounter/this.compassIntervalPeriod) % 4 ===1) {
            this.compassState = 'vertical'
          } else if ((this.compassTimeCounter/this.compassIntervalPeriod) % 4 ===0) {
            this.compassState = 'left'
          } else if ((this.compassTimeCounter/this.compassIntervalPeriod) % 4 ===3) {
            this.compassState = 'horizontal'
          } else if ((this.compassTimeCounter/this.compassIntervalPeriod) % 4 ===2) {
            this.compassState = 'right'
          }
        } else {
          this.compassState = ''
        }
        this.compassTimeCounter += this.compassIntervalPeriod
        
      }, this.compassIntervalPeriod)
    }
  },
  beforeDestroy () {
    clearInterval(this.compassInterval)
  }
}
</script>

<style lang="scss">
.compass {
  position: absolute;
  width: fluid(103px);
  height: fluid(85px);
  position: absolute;
  top: 0;
  left: fluid(35px);
  &__still {
    background-image: url('~@/assets/img/compass-still.png');
    width: fluid(115px);
    height: fluid(115px);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
  }
  &__vertical {
    background-image: url('~@/assets/img/compass-vertical.png');
    width: fluid(115px);
    height: fluid(115px);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    display: none;
  }
  &__left {
    background-image: url('~@/assets/img/compass-left.png');
    width: fluid(115px);
    height: fluid(115px);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    display: none;
  }
  &__horizontal {
    background-image: url('~@/assets/img/compass-horizontal.png');
    width: fluid(115px);
    height: fluid(115px);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    display: none;
  }
  &__right {
    background-image: url('~@/assets/img/compass-right.png');
    width: fluid(115px);
    height: fluid(115px);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    display: none;
  }
  &.vertical {
    .compass {
      &__still {
        display: none;
      }
      &__vertical {
        display: block;
      }
    }
  }
  &.left {
    .compass {
      &__still {
        display: none;
      }
      &__left {
        display: block;
      }
    }
  }
  &.horizontal {
    .compass {
      &__still {
        display: none;
      }
      &__horizontal {
        display: block;
      }
    }
  }
  &.right {
    .compass {
      &__still {
        display: none;
      }
      &__right {
        display: block;
      }
    }
  }
}
</style>